<div class="cc-app-routing-error">
  <cc-error-page *ngIf="(showAppPlaceholder$ | async) === false; else appPlaceholder" />
  <ng-template #appPlaceholder>
    <cc-lazy-host [componentId]="appPlaceholderComponent" />
  </ng-template>
</div>
